<template>
  <div
    class="board-component presets"
    :class="{
      'bg-white': showPresetsContent,
      'presets--closed': !showPresetsContent,
    }"
  >
    <div
      class="presets__content"
      :class="{
        'bg-white sombra': showPresetsContent,
      }"
      :style="{
        width: !showGroups && 'auto',
      }"
    >
      <button
        v-if="showPresetsContent"
        class="presets__close"
        @click="togglePresetListDisplay()"
      >
        <IconClose />
      </button>

      <div
        class="presets__button bg-white no-select"
        @click="togglePresetListDisplay()"
      >
        <span class="f-12 p-600 cl-gray-72 pointer no-select">
          <IconDashboard class="text-primary" />
          <span>Módulos</span>
        </span>
      </div>

      <div
        v-show="showGroups"
        class="presets__groups"
      >
        <div class="field no-select search">
          <IconSearch size="sm" />
          <input
            id="modelPath"
            ref="search__field"
            v-model="searchTerm"
            class="form-control search__field"
            type="text"
            placeholder="Buscar módulo"
            @input="setCategoryType(null)"
          />
        </div>

        <ul class="presets__groups__list">
          <li
            v-for="(group, index) in groupList"
            :key="index"
            class="presets__groups__list__item no-select"
            :class="{
              'presets__groups__list__item--active': isGroupActive(
                group.category,
              ),
            }"
            @click="setCategoryType(group.category)"
          >
            {{ group.label }}
            <IconArrow
              size="xs"
              direction="right"
            />
          </li>
        </ul>
      </div>
      <div
        v-show="showPresetsContent"
        class="presets__list-content bg-white"
        :class="{
          'presets__list-content--open': listOpened && showGroups,
          'presets__list-content--outside sombra': showGroups,
        }"
      >
        <div class="custom-scrollbar">
          <div class="presets__list-content__scroller">
            <div v-if="hasFilteredPresets">
              <span
                class="helper-text f-11 p-400 cl-gray-50"
                :class="{ 'has-error': limitPresets }"
              >
                {{ message }}
              </span>
              <ul
                class="presets__list-content__list"
                :class="{
                  'presets__list-content__list--col-1': showSingleColumn,
                }"
              >
                <li
                  v-for="preset in filteredEnabledPresets"
                  :key="preset.name"
                  class="presets__item"
                  :disabled="isViewerUser"
                  @click="setPreset(preset)"
                >
                  <div class="presets__item__thumb no-select">
                    <div
                      v-show="hasRibbon(preset)"
                      class="presets__item__thumb-ribbon"
                    >
                      <span>{{ getRibbonText(preset) }}</span>
                    </div>
                    <img
                      :src="preset.image"
                      :alt="preset.name"
                    />
                  </div>
                  <h3
                    class="presets__item__title text-align-center f-11 cl-gray-72 no-select"
                  >
                    {{ preset.name }}
                  </h3>
                </li>
              </ul>
            </div>
            <div
              v-else
              class="presets__list-content__empty"
            >
              <span class="presets__list-content__empty__title">
                Nenhum módulo<br />
                encontrado<br />
                🙁
              </span>
              <span class="presets__list-content__empty__text">
                Busque novamente com outro descritivo ou selecione um módulo na
                listagem.
              </span>
              <button
                class="btn btn-primary"
                @click="newSearch"
              >
                Busca novamente
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

import presets from '@/store/dicts/presets';
import moduleCategory from '@/store/dicts/moduleCategory';
import modalPresets from '@/store/dicts/modalPresets';
import modalModuleCategory from '@/store/dicts/modalModuleCategory';
import IconArrow from '@/components/icons/IconArrow.vue';
import IconClose from '@/components/icons/IconClose.vue';
import IconDashboard from '@/components/icons/IconDashboard.vue';
import IconSearch from '@/components/icons/IconSearch.vue';
import slugify from 'slugify';

export default {
  name: 'PresetList',
  components: {
    IconArrow,
    IconClose,
    IconDashboard,
    IconSearch,
  },
  data() {
    return {
      moduleCategory,
      searchTerm: '',
      categoryType: null,
    };
  },
  computed: {
    presets() {
      return this.container.type === 'modals' ? modalPresets : presets;
    },
    showGroups() {
      return this.presets.length > 5;
    },
    limitPresets() {
      return this.container.type !== 'pages' && this.instanceCount >= 1;
    },
    message() {
      if (this.limitPresets) {
        return 'Você pode adicionar apenas um módulo por pop-up';
      }
      return 'Clique no módulo para adicionar';
    },
    enabledPresets() {
      return this.presets.filter((preset) => this.isPresetEnabled(preset));
    },
    hasFilteredPresets() {
      return this.filteredEnabledPresets.length > 0;
    },
    filteredEnabledPresets() {
      return this.presetsList.filter((preset) =>
        this.checkCategory(preset, this.categoryType),
      );
    },
    foundOutPresets() {
      return this.enabledPresets.filter((preset) => this.findPreset(preset));
    },
    presetsList() {
      return this.searchTerm.length > 0
        ? this.foundOutPresets
        : this.enabledPresets;
    },
    listOpened() {
      return this.showPresetsContent;
    },
    groupList() {
      if (this.container.type === 'modals') {
        return [
          {
            label: 'Ver todos',
            category: null,
          },
          {
            label: 'Pop-ups',
            category: modalModuleCategory.POPUP,
          },
          {
            label: 'Conteúdo',
            category: modalModuleCategory.CONTENT,
          },
        ];
      }

      const categories = [
        {
          label: 'Ver todos',
          category: null,
        },
        {
          label: 'Cabeçalhos e rodapés',
          category: moduleCategory.HEADER_FOOTER,
        },
        {
          label: 'Textos e conteúdos',
          category: moduleCategory.CONTENT_TEXT,
        },
        {
          label: 'Fotos e vídeos',
          category: moduleCategory.CONTENT_IMAGES,
        },
        {
          label: 'Sliders e carrosséis',
          category: moduleCategory.SLIDERS,
        },
        {
          label: 'Formulários',
          category: moduleCategory.LEADS,
        },
        {
          label: 'Acomodações',
          category: moduleCategory.ACCOMMODATIONS,
        },
        {
          label: 'Promoções',
          category: moduleCategory.PROMOTIONS,
        },
        {
          label: 'Conectados ao Letsbook',
          category: moduleCategory.LETSBOOK,
        },
        {
          label: 'Conectados ao CRM',
          category: moduleCategory.CRM,
        },
        {
          label: 'Outros',
          category: moduleCategory.OTHERS,
        },
      ];

      return categories;
    },
    showSingleColumn() {
      return this.filteredEnabledPresets.length <= 3;
    },
    ...mapState(['showPresetsContent', 'instances']),
    ...mapGetters(['container', 'instanceCount', 'activePage', 'isViewerUser']),
  },
  watch: {
    showPresetsContent(show) {
      if (!show) {
        this.setCategoryType(null);
      }
    },
  },
  methods: {
    newSearch() {
      this.searchTerm = '';
      this.setCategoryType(null);
      this.$refs.search__field.focus();
    },
    findPreset(preset) {
      const term = slugify(this.searchTerm, { lower: true, strict: true });
      const presetKeywords = preset.keywords || [];

      const presetInfo = [
        preset.name,
        preset.module,
        ...presetKeywords,
        preset.isNew ? 'novo' : '',
        preset.isUpdated ? 'atualizado' : '',
      ];

      const presetSlug = slugify(presetInfo.join(' '), {
        lower: true,
        strict: true,
      });
      return presetSlug.includes(term);
    },
    isGroupActive(type) {
      return this.categoryType === type;
    },
    setCategoryType(type) {
      this.categoryType = type;
    },
    hasRibbon(preset) {
      return preset.isNew || preset.isUpdated;
    },
    getRibbonText(preset) {
      if (preset.isUpdated) {
        return 'Atualizado';
      }

      return 'Novo';
    },
    moduleAlreadyExistsOnPage(module) {
      return Object.values(this.instances).some(
        (instance) =>
          instance.module === module &&
          this.activePage.instanceList.includes(instance.id),
      );
    },
    isPresetEnabled(preset) {
      if (preset.unique) {
        if (
          (preset.module === 'Widget' &&
            this.moduleAlreadyExistsOnPage('WidgetLight')) ||
          (preset.module === 'WidgetLight' &&
            this.moduleAlreadyExistsOnPage('Widget'))
        ) {
          return false;
        }
      }

      if (preset.unique && this.moduleAlreadyExistsOnPage(preset.module)) {
        return false;
      }

      switch (typeof preset.isEnabled) {
        case 'boolean':
          return preset.isEnabled;

        case 'function':
          return preset.isEnabled({
            ...this.$store.state,
            ...this.$store.getters,
          });

        default:
          return true;
      }
    },
    checkCategory(preset, category) {
      return category ? preset.category.includes(category) : true;
    },
    setPreset(preset) {
      if (!this.limitPresets) {
        this.addPresetToActiveContainer(preset);
        if (this.container.type !== 'pages') {
          this.togglePresetListDisplay();
        }
      }
    },
    ...mapActions(['addPresetToActiveContainer', 'togglePresetListDisplay']),
  },
};
</script>

<style scoped lang="scss">
.presets {
  z-index: 5;

  .sombra {
    box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.15);
  }

  $P: &;

  &__content {
    padding: 15px 15px 0px;
    height: calc(100vh - 55px - 14px);
    position: fixed;
    left: 0;
    top: 45px;
    width: 185px;
    z-index: 6;
  }

  &__close {
    float: right;
    cursor: pointer;
    margin: 8px 0;
  }

  &--closed {
    z-index: 2;
    overflow: hidden;
    box-shadow: none;

    #{$P}__button {
      width: 135px;

      &:hover {
        border: 1px solid $crm-blue-hover2;
        box-shadow: 0px 5px 10px fade-out($crm-blue-hover2, 0.6);

        .icon {
          opacity: 0.8;
        }

        span {
          color: $crm-blue-primary;
        }
      }
    }

    #{$P}__groups {
      display: none;
    }

    .presets {
      &__content {
        height: auto;
        width: auto;
        padding-right: 0;
      }
    }

    .presets__button {
      box-shadow: 0px 12px 24px rgba(0, 0, 0, 0.15);
      // needs to be inside 'presets--closed' class so it will only have shadow when options are closed
    }
  }

  &__button {
    height: 40px;
    width: 70px;
    border-radius: 20px;
    display: flex;
    justify-content: left;
    align-items: center;
    border-color: $crm-blue-hover2; // avoid transition from black
    transition: all 0.3s ease-in-out;
    white-space: nowrap;
    cursor: pointer;

    .icon {
      margin: 0 10px;
    }
  }

  &__groups {
    .search {
      position: relative;

      i {
        position: absolute;
        right: 0;
        top: 0;
        margin: 6px 0;
      }

      &__field {
        background: none;
        padding-right: 25px;

        &::placeholder {
          color: #949494;
        }
      }
    }

    &__list {
      list-style: none;
      margin-top: 15px;

      &__item {
        margin-bottom: 2px;
        padding: 6px 0;
        font-size: $size-smaller;
        font-style: normal;
        display: flex;
        align-items: center;
        font-weight: $lb-medium;
        line-height: 18px;
        letter-spacing: 0px;
        text-align: left;
        cursor: pointer;

        &--active {
          color: $crm-blue-primary;
          font-weight: $lb-semibold;

          .arrow {
            path {
              fill: $crm-blue-primary;
            }
          }
        }

        .arrow {
          width: 16px;
          float: right;
        }
      }
    }
  }

  &__list-content {
    height: calc(100% - 40px);

    &__list {
      display: grid;
      grid-template: auto / 1fr 1fr;
      gap: 16px;

      &--col-1 {
        grid-template: auto / 1fr;
      }
    }

    &--outside {
      position: fixed;
      left: 0;
      top: 0;
      height: calc(100vh - 55px - 14px);
      margin: 45px 0 0 -1000px;
      z-index: 5;
      transition: margin 0.3s ease-in-out;
    }

    &--open {
      margin-left: 185px;
    }

    .helper-text {
      width: 100%;
      margin-bottom: 24px;
      text-align: center;
      display: block;
    }

    .custom-scrollbar {
      height: 100%;
      margin: 0;
    }

    &__scroller {
      padding: 16px;
      width: auto;
    }

    &__empty {
      padding: 52px 30px;
      text-align: center;
      display: flex;
      flex-direction: column;
      max-width: 220px;

      &__title {
        display: inline-block;
        font-size: $size-small;
        font-style: normal;
        font-weight: $lb-bold;
        line-height: 21px;
        letter-spacing: 0em;
        text-align: center;
        margin-bottom: 20px;
      }

      &__text {
        display: inline-block;
        margin-bottom: 20px;
        font-size: $size-smaller;
        font-style: normal;
        font-weight: $lb-medium;
        line-height: 18px;
        letter-spacing: 0em;
        text-align: center;
      }
    }
  }

  &__item {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    margin-bottom: 8px;

    &[disabled] {
      pointer-events: none;
    }

    &:hover {
      .presets__item__thumb {
        outline: 1px solid $crm-blue-primary;
        border-color: $crm-blue-primary;

        &::before {
          opacity: 0.3;
        }
        &::after {
          opacity: 1;
        }
      }
    }

    &__thumb {
      border-radius: 2px;
      display: flex;
      background: #d9d9d9;
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
      border-radius: 4px;
      margin: auto 0;
      width: 220px;
      height: 110px;
      overflow: hidden;
      position: relative;

      img {
        margin: auto 0;
      }

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: $crm-blue-primary;
        opacity: 0;
        transition: all 0.2s ease-in-out;
      }

      &::after {
        content: 'Clique para adicionar';
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: $crm-blue-primary;
        border-radius: 50px;
        width: 134px;
        height: 25px;
        color: $lb-white;
        font-size: $size-smaller;
        line-height: 25px;
        text-align: center;
        margin: auto;
        opacity: 0;
        transition: all 0.2s ease-in-out;
      }

      // Base ribbon style from https://www.cssportal.com/css-ribbon-generator/
      &-ribbon {
        overflow: hidden;
        position: absolute;
        right: -5px;
        top: -5px;
        text-align: right;
        width: 75px;
        height: 75px;
        z-index: 1;

        span {
          -webkit-transform: rotate(45deg);
          background: #79a70a;
          background: linear-gradient(#9bc90d 0%, #79a70a 100%);
          color: $lb-white;
          display: block;
          font-size: 10px;
          line-height: 20px;
          position: absolute;
          text-align: center;
          text-transform: uppercase;
          top: 19px;
          right: -21px;
          transform: rotate(45deg);
          width: 100px;

          &::before {
            border-bottom: 3px solid transparent;
            border-left: 3px solid #79a70a;
            border-right: 3px solid transparent;
            border-top: 3px solid #79a70a;
            content: '';
            position: absolute;
            left: 0px;
            top: 100%;
            z-index: -1;
          }

          &::after {
            border-bottom: 3px solid transparent;
            border-left: 3px solid transparent;
            border-right: 3px solid #79a70a;
            border-top: 3px solid #79a70a;
            content: '';
            position: absolute;
            right: 0px;
            top: 100%;
            z-index: -1;
          }
        }
      }
    }

    &__title {
      margin-top: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
